import api from '../api'

export default {
    namespaced: true,
    state: {
        clubRecharge: {// 俱乐部平台充值订单
            beanList: [],
            total: 0,
            totalOrderPrice: 0// 总充值
        },
        payChannelRecharge: {// 渠道平台充值订单
            beanList: [],
            total: 0,
            totalOrderPrice: 0// 总充值
        },
        playerMallRecharge: {// 玩家商城充值订单
            beanList: [],
            total: 0,
            totalOrderPrice: 0// 总充值
        },
    },
    mutations: {
        setStateClubRecharge(state, info) {
            state.clubRecharge = info
        },
        setStatePayChannelRecharge(state, info) {
            state.payChannelRecharge = info
        },
        setStatePlayerMallRecharge(state, info) {
            state.playerMallRecharge = info
        }
    },
    actions: {
        centerRechargeList(store, params) {
            return api.post('/rechargeOrders/center', '中央收付充值', params).then(res => {
                return res.data
            })
        },
        clubRechargeList({commit}, params) {
            return api.post('/rechargeOrders/club', '俱乐部平台充值订单', params).then(res => {
                commit('setStateClubRecharge', res.data)
            })
        },
        payChannelRechargeList({commit}, params) {
            return api.post('/rechargeOrders/payChannel', '渠道平台充值订单', params).then(res => {
                commit('setStatePayChannelRecharge', res.data)
            })
        },
        playerRechargeList(store, params) {
            return api.post('/rechargeOrders/player', '玩家平台充值订单', params).then(res => {
                return res.data
            })
        },
        playerMallRechargeList({commit}, params) {
            return api.post('/rechargeOrders/playerMall', '玩家商城充值订单', params).then(res => {
                commit('setStatePlayerMallRecharge', res.data)
            })
        },
        rechargeOrdersManualHandling(store, params) {
            return api.post('/rechargeOrders/manual_handling', '人工处理订单', params)
        }
    }
}